import { AmplitudeEventProperty, logAmplitudeEvent } from 'chairisher/util/analytics';

/**
 * Tracks an event related to the applying or removing of a sugggestion from a form.
 *
 * @param {string} eventName The name of the event to track
 * @param {Choice} suggestionChoice The datastructure that representing the suggestion being tracked
 * @param {number=} productId Optional number indicating which product the event is for
 * @param {boolean=} isBulkApply Optional flag indicating if the apply was a part of a bulk apply where
 *   multiple suggestions were added at once.
 */
function trackSuggestionEvent(eventName, suggestionChoice, productId, isBulkApply) {
    const amplitudeEventObject = {
        [AmplitudeEventProperty.DISPLAY]: suggestionChoice.display,
        [AmplitudeEventProperty.FIELD_NAME]: suggestionChoice.fieldName,
        [AmplitudeEventProperty.VALUE]: suggestionChoice.value,
    };

    if (isBulkApply !== undefined) {
        amplitudeEventObject[AmplitudeEventProperty.IS_BULK_APPLY] = Boolean(isBulkApply);
    }

    if (productId) {
        amplitudeEventObject[AmplitudeEventProperty.PRODUCT_ID] = productId;
    }
    if (suggestionChoice.taxonomy) {
        amplitudeEventObject[AmplitudeEventProperty.TAXONOMY] = suggestionChoice.taxonomy;
    }

    logAmplitudeEvent(eventName, amplitudeEventObject);
}

/**
 * Tracks when a suggestion is applied to the form
 *
 * @param {Choice} suggestionChoice The datastructure that representing the suggestion being tracked
 * @param {number=} productId Optional number indicating which product the suggestion was added to
 * @param {boolean=} isBulkApply Optional flag indicating if the apply was a part of a bulk apply where
 *   multiple suggestions were added at once.
 */
export function trackSuggestionApply(suggestionChoice, productId, isBulkApply) {
    trackSuggestionEvent('suggestion - apply', suggestionChoice, productId, isBulkApply);
}

/**
 * Tracks when a suggestion is removed from the form via user interaction
 *
 * @param {Choice} suggestionChoice The datastructure that representing the suggestion being tracked
 * @param {number=} productId Optional number indicating which product the suggestion was removed from
 */
export function trackSuggestionCancel(suggestionChoice, productId) {
    trackSuggestionEvent('suggestion - cancel', suggestionChoice, productId);
}
